var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "leave-active-class": "duration-200"
    }
  }, [_vm.showing === true && _vm.loadingData === false ? _c('div', {
    staticClass: "z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center",
    on: {
      "keydown": function ($event) {
        return _vm.$refs.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.$refs.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_c('div', {
    staticClass: "fixed inset-0 transition-opacity",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('div', {
    staticClass: "absolute inset-0 bg-indigo-600 bg-opacity-85"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded-lg px-4 pt-5 pb-4 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full sm:p-6",
    attrs: {
      "aria-labelledby": "modal-headline",
      "aria-modal": "true",
      "role": "dialog"
    },
    on: {
      "scroll": function ($event) {
        return _vm.$refs.progressbar.reduceProgressBar($event);
      }
    }
  }, [_c('div', {
    staticClass: "cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600",
    on: {
      "click": function ($event) {
        return _vm.closePopup();
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sticky flex flex-col items-center top-0 z-10"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.messageHeader.type != '' && _vm.messageHeader.msg != '' ? _c('div', {
    staticClass: "absolute z-50 min-w-max text-center py-5 mt-10 text-base flex items-center justify-center",
    class: {
      'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600': _vm.messageHeader == 'saveIsSuccess' || _vm.messageHeader == 'transferIsSuccess',
      'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600': _vm.messageHeader == 'error' || _vm.messageHeader == 'noName' || _vm.messageHeader == 'lastActivity' || _vm.messageHeader === 'evaluationInProgress',
      'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600': _vm.messageHeader == 'noSave'
    }
  }, [_c('div', [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_vm.messageHeader == 'saveIsSuccess' || _vm.messageHeader == 'transferIsSuccess' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }) : _vm.messageHeader == 'error' || _vm.messageHeader == 'noName' || _vm.messageHeader == 'lastActivity' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm.messageHeader == 'noSave' ? _c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "alert-triangle"
    }
  }) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'saveIsSuccess' ? _c('div', [_vm._v("\n                  Vos données ont été enregistrées.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'transferIsSuccess' ? _c('div', [_vm._v("\n                  La fiche de poste à bien été transférée.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'evaluationInProgress' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas modifier une fiche de poste utilisée par\n                  une évaluation.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'error' ? _c('div', [_vm._v("\n                  Erreur d'enregistrement des données.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'lastActivity' ? _c('div', [_vm._v("\n                  Vous ne pouvez pas supprimer la dernière activité.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'noName' ? _c('div', [_vm._v("\n                  Veuillez remplir le champ \"nom du poste\"\n                  "), _c('br'), _vm._v("\n                  pour enregistrer la fiche.\n                ")]) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'noSave' ? _c('div', [_vm._v("\n                  Vous avez des modifications non sauvegardées."), _c('br')]) : _vm._e()], 1), _vm._v(" "), _vm.messageHeader == 'noSave' ? _c('div', {
    staticClass: "mt-5"
  }, [_c('button', {
    staticClass: "border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4",
    on: {
      "click": function ($event) {
        return _vm.cancel_nosave();
      }
    }
  }, [_vm._v("\n                  ANNULER\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2",
    on: {
      "click": function ($event) {
        return _vm.closeWithoutSaving();
      }
    }
  }, [_vm._v("\n                  QUITTER\n                ")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _vm.editable && _vm.$can(_vm.constants.PERMISSION_FICHE_DE_POSTE_PERSONNELLE_EDITER) ? _c('div', {
    staticClass: "absolute right-15 mt-13 flex items-center justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]) : !_vm.editable && _vm.$can(_vm.constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_EDITER) ? _c('div', {
    staticClass: "absolute right-15 mt-13 flex items-center justify-center"
  }, [_vm.saving ? _c('div', {
    staticClass: "w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
  }, [_c('span', {
    staticClass: "h-6 w-6 ml-4 mt-1/4 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14",
    on: {
      "click": _vm.save_datas
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6 ml-4 mt-1/4",
    attrs: {
      "name": "save"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _vm.editable ? _c('progress-bar', {
    ref: "progressbar",
    attrs: {
      "in-popup": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-5 md:m-15 grid grid-cols-12"
  }, [_vm.form.nom_du_poste == '' || _vm.form.nom_du_poste == null ? _c('h3', {
    staticClass: "col-span-full"
  }, [_vm._v("\n          Nouveau poste\n        ")]) : _c('h3', {
    staticClass: "col-span-full"
  }, [_vm._v("\n          " + _vm._s(_vm.form.nom_du_poste) + "\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "col-span-full text-indigo-600 my-10"
  }, [_vm._v("\n          Informations de base\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-4"
  }, [_c('input-text', {
    class: 'lg:col-span-4',
    attrs: {
      "name": "nom_du_poste",
      "libelle": "Nom du poste",
      "necessary": true,
      "value": _vm.form.nom_du_poste,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.nom_du_poste = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "sector",
      "libelle": "Secteur d'activité",
      "necessary": true,
      "datas": _vm.categories,
      "value": _vm.form.sector,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.sector = newValue;
        _vm.setIndex(newValue);
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "family",
      "libelle": "Famille professionnelle",
      "necessary": true,
      "value": _vm.form.family,
      "datas": _vm.listFamilies,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.family = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "mission",
      "libelle": "Mission(s)",
      "size": 5,
      "necessary": true,
      "value": _vm.form.mission,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.mission = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "objectif",
      "libelle": "Objectif(s)",
      "size": 5,
      "necessary": true,
      "value": _vm.form.objectif,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.objectif = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "contexte_organisationnel",
      "libelle": "Contexte Organisationnel",
      "size": 5,
      "necessary": true,
      "value": _vm.form.contexte_organisationnel,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.contexte_organisationnel = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "passerelle_mobilité",
      "libelle": "Passerelle de mobilité",
      "size": 5,
      "necessary": true,
      "value": _vm.form.passerelle_mobilité,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.passerelle_mobilité = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "formation_experience",
      "libelle": "Formation(s) - Expérience(s)",
      "size": 5,
      "necessary": true,
      "value": _vm.form.formation_experience,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.formation_experience = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-4 my-10"
  }, [_c('h4', {
    staticClass: "text-indigo-600 col-span-full"
  }, [_vm._v("\n              Référentiels correspondants\n            ")]), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rome",
      "libelle": "ROME",
      "necessary": false,
      "value": _vm.form.rome,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rome = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rsfp",
      "libelle": "RSFP",
      "necessary": false,
      "value": _vm.form.rsfp,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rsfp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "rncp",
      "libelle": "Diplômes et titre (RNCP)",
      "necessary": false,
      "value": _vm.form.rncp,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.rncp = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-3",
    attrs: {
      "name": "convention_collective",
      "libelle": "Conventions collectives",
      "necessary": false,
      "value": _vm.form.convention_collective,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.convention_collective = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative col-span-full"
  }, [_c('div', {
    staticClass: "my-10"
  }, [_c('div', {
    staticClass: "w-full flex flex-col justify-center items-center mb-10"
  }, [_c('div', {
    staticClass: "max-w-8/10 flex flex-col items-end"
  }, [_c('div', {
    staticClass: "flex flex-row justify-center items-center cursor-pointer w-full",
    on: {
      "click": [_vm.displayActivitylist, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "flex flex-row items-end justify-center ml-2"
  }, [_c('h4', {
    staticClass: "text-indigo-600 text-center select-none"
  }, [_vm._v("\n                        " + _vm._s(_vm.activityTitle) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
  }, [_c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activitylist relative w-60 h-0"
  }, [_vm.showList ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayActivitylist,
      expression: "displayActivitylist"
    }],
    staticClass: "absolute w-full flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._l(_vm.form.activities, function (activity, i) {
    return _c('div', {
      key: i,
      staticClass: "first:pt-2 py-1"
    }, [_c('p', {
      staticClass: "text-gray-600 hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          _vm.currentActivity = i;
        }
      }
    }, [_c('span', [_vm._v(_vm._s('Activité ' + (i + 1) + ' : ' + activity.activity_name))])])]);
  }), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "border-t pt-2 mt-5 text-gray-600 hover:text-gray-900 cursor-pointer",
    on: {
      "click": _vm.addActivity
    }
  }, [_c('span', [_vm._v("Ajouter une activité")])]) : _vm._e()], 2)])]) : _vm._e()])])]), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "flex items-center justify-between mb-10"
  }, [_c('delete-button', {
    attrs: {
      "libelle": "Supprimer l'activité"
    },
    on: {
      "del": _vm.deleteActivity
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-none w-max relative"
  }, [_c('action-button', {
    attrs: {
      "responsive": "",
      "bg-color": "bg-orange-300",
      "bg-color-square": "bg-orange-100",
      "border-color": "border-transparent",
      "icon": "swap",
      "icon-color": "text-orange-600",
      "libelle": "Intervertir les activités",
      "text-color": "text-gray-900"
    },
    on: {
      "clickAction": _vm.displayInvertActivitiesMenu
    }
  }), _vm._v(" "), _vm.isInvertActivitiesMenuDisplayed ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.hideInvertActivitiesMenu,
      expression: "hideInvertActivitiesMenu"
    }],
    staticClass: "z-20 absolute right-0 top-13 text-sm w-max max-w-md bg-white rounded-md shadow-md shadow-gray-600 px-6 py-5 cursor-default flex flex-col space-y-1"
  }, [_c('draggable', _vm._b({
    on: {
      "start": function ($event) {
        _vm.drag = true;
      },
      "end": function ($event) {
        _vm.drag = false;
      }
    },
    model: {
      value: _vm.form.activities,
      callback: function ($$v) {
        _vm.$set(_vm.form, "activities", $$v);
      },
      expression: "form.activities"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l(_vm.form.activities, function (activity, iAct) {
    return _c('div', {
      key: 'A' + iAct
    }, [_c('div', {
      staticClass: "grid grid-cols-12 cursor-pointer items-center"
    }, [_c('icon', {
      staticClass: "text-indigo-600 col-span-1",
      attrs: {
        "name": "move"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-gray-600 hover:text-gray-900 col-span-11"
    }, [_vm._v("\n                              " + _vm._s(activity.activity_name) + "\n                            ")])], 1), _vm._v(" "), iAct < _vm.form.activities.length - 1 ? _c('hr', {
      staticClass: "my-2.5 border-indigo-300"
    }) : _vm._e()]);
  }), 0)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.form.activities, function (activity, index) {
    return _c('div', {
      key: 'activitygeneral' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentActivity === index,
        expression: "currentActivity === index"
      }]
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-4"
    }, [_c('input-text', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "activity_name",
        "libelle": "Activité",
        "necessary": true,
        "value": _vm.form.activities[index].activity_name,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_name = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "evolution",
        "libelle": "Evolution de l'activité en N+1",
        "necessary": true,
        "datas": [{
          value: 'Reconduite'
        }, {
          value: 'Modifiée'
        }, {
          value: 'Supprimée'
        }, {
          value: 'Renforcée'
        }],
        "value": _vm.form.activities[index].activity_evolution,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_evolution = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "situation",
        "libelle": "Situation de l'activité",
        "necessary": true,
        "datas": [{
          value: 'Individuelle'
        }, {
          value: 'Collective'
        }, {
          value: 'Individuelle et collective'
        }],
        "value": _vm.form.activities[index].activity_situation,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_situation = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "posture",
        "libelle": "Posture de travail",
        "necessary": true,
        "datas": [{
          value: 'Statique assis'
        }, {
          value: 'Statique debout'
        }, {
          value: 'En mouvement'
        }],
        "value": _vm.form.activities[index].activity_posture,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_posture = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "risque",
        "libelle": "Activité à risque",
        "necessary": true,
        "datas": [{
          value: 'Oui'
        }, {
          value: 'Non'
        }],
        "value": _vm.form.activities[index].activity_risk,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_risk = newValue;
        }
      }
    }), _vm._v(" "), _vm.form.activities[index].activity_risk === 'Oui' ? _c('input-text', {
      class: (_vm.form.activities[index].activity_risk == 'Oui' ? 'lg:col-span-3' : 'lg:col-span-0') + ' transition',
      attrs: {
        "name": "risktype",
        "libelle": "Type de risque",
        "necessary": true,
        "value": _vm.form.activities[index].activity_risktype,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_risktype = newValue;
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('multiple-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "outillage",
        "libelle": "Outillage utilisé",
        "necessary": true,
        "value": _vm.form.activities[index].activity_tools,
        "datas": [{
          value: 'Poste sans outillage'
        }, {
          value: 'Outil informatique'
        }, {
          value: 'Petit outillage'
        }, {
          value: 'Machine simple'
        }, {
          value: 'Machine complexe'
        }, {
          value: 'Machines et outillages divers'
        }],
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_tools = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "time",
        "libelle": "Temps consacré",
        "necessary": true,
        "datas": [{
          value: 'Majeur (+ de 50% du temps)'
        }, {
          value: 'Secondaire (- de 50% du temps)'
        }, {
          value: 'Mineur (- de 10% du temps)'
        }],
        "value": _vm.form.activities[index].activity_time,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_time = newValue;
        }
      }
    }), _vm._v(" "), _c('input-select', {
      staticClass: "lg:col-span-3",
      attrs: {
        "name": "level",
        "libelle": "Niveau de maitrise requis",
        "necessary": true,
        "datas": [{
          value: '1. Connaissance de base'
        }, {
          value: '2. Intermédiaire'
        }, {
          value: '3. Confirmé'
        }, {
          value: '4. Expert'
        }],
        "value": _vm.form.activities[index].activity_level,
        "disabled": !_vm.editable
      },
      on: {
        "input": function (newValue) {
          _vm.form.activities[index].activity_level = newValue;
        }
      }
    })], 1)])]);
  })], 2), _vm._v(" "), _vm._l(_vm.form.activities, function (activity, bigindex) {
    return _c('div', {
      key: 'activitytasks' + bigindex
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentActivity === bigindex,
        expression: "currentActivity === bigindex"
      }]
    }, [_c('div', {
      staticClass: "grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10"
    }, [_c('h5', {
      staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
    }, [_vm._v("\n                    Tâches Principales\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10",
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.activities[bigindex].activity_tasks,
        callback: function ($$v) {
          _vm.$set(_vm.form.activities[bigindex], "activity_tasks", $$v);
        },
        expression: "form.activities[bigindex].activity_tasks"
      }
    }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.activities[bigindex].activity_tasks, function (task, index) {
      return _c('div', {
        key: 'A' + index,
        staticClass: "col-span-full sm:col-span-6 flex items-center relative"
      }, [_c('input-text-with-action', {
        class: {
          'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.task == index
        },
        style: _vm.editable ? 'cursor:grab' : '',
        attrs: {
          "libelle": "",
          "name": 'task' + index,
          "necessary": true,
          "value": task.name,
          "disabled": !_vm.editable,
          "is-grabable": true,
          "draggable": true,
          "placeholder": "Saisir le nom de la tâche",
          "prefix-text": index + 1 + '. '
        },
        on: {
          "input": function (newValue) {
            task.name = newValue;
          },
          "switchDraggable": function (newValue) {
            _vm.isDraggable = newValue;
          },
          "duplicate": function ($event) {
            return _vm.duplicateTask(task, index);
          },
          "delete": function ($event) {
            return _vm.deleteFromActivity(_vm.form.activities[bigindex].activity_tasks, index);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('add-button', {
      staticClass: "col-span-full flex items-center w-max",
      attrs: {
        "libelle": "Ajouter une tâche",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addToActivity(_vm.form.activities[bigindex].activity_tasks);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10"
    }, [_c('h5', {
      staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
    }, [_vm._v("\n                    Pratiques professionnelles : être capable de...\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10",
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.activities[bigindex].activity_pratiques_pros,
        callback: function ($$v) {
          _vm.$set(_vm.form.activities[bigindex], "activity_pratiques_pros", $$v);
        },
        expression: "\n                      form.activities[bigindex].activity_pratiques_pros\n                    "
      }
    }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.activities[bigindex].activity_pratiques_pros, function (pratiques_pro, index) {
      return _c('div', {
        key: 'A' + index,
        staticClass: "col-span-full sm:col-span-6 flex items-center"
      }, [_c('input-text-with-action', {
        class: {
          'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.pratique == index
        },
        style: _vm.editable ? 'cursor:grab' : '',
        attrs: {
          "libelle": "",
          "name": 'pratique' + index,
          "necessary": true,
          "value": pratiques_pro.name,
          "disabled": !_vm.editable,
          "is-grabable": true,
          "placeholder": "Saisir le nom de la pratique professionnelle",
          "draggable": true,
          "prefix-text": index + 1 + '. '
        },
        on: {
          "input": function (newValue) {
            pratiques_pro.name = newValue;
          },
          "switchDraggable": function (newValue) {
            _vm.isDraggable = newValue;
          },
          "duplicate": function ($event) {
            return _vm.duplicatePratique(pratiques_pro, index);
          },
          "delete": function ($event) {
            return _vm.deleteFromActivity(_vm.form.activities[bigindex].activity_pratiques_pros, index);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('add-button', {
      staticClass: "col-span-full flex items-center w-max",
      attrs: {
        "libelle": "Ajouter une pratique professionnelle",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addToActivity(_vm.form.activities[bigindex].activity_pratiques_pros);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10"
    }, [_c('h5', {
      staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
    }, [_vm._v("\n                    Connaissances associées : théorique, procédurale...\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10",
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.activities[bigindex].activity_connaissances,
        callback: function ($$v) {
          _vm.$set(_vm.form.activities[bigindex], "activity_connaissances", $$v);
        },
        expression: "form.activities[bigindex].activity_connaissances"
      }
    }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.activities[bigindex].activity_connaissances, function (connaissance, index) {
      return _c('div', {
        key: 'A' + index,
        staticClass: "col-span-full sm:col-span-6 flex items-center"
      }, [_c('input-text-with-action', {
        class: {
          'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.connaissance == index
        },
        style: _vm.editable ? 'cursor:grab' : '',
        attrs: {
          "libelle": "",
          "name": 'connaissance' + index,
          "necessary": true,
          "value": connaissance.name,
          "disabled": !_vm.editable,
          "is-grabable": true,
          "placeholder": "Saisir le nom de la connaissance",
          "draggable": true,
          "prefix-text": index + 1 + '. '
        },
        on: {
          "input": function (newValue) {
            connaissance.name = newValue;
          },
          "switchDraggable": function (newValue) {
            _vm.isDraggable = newValue;
          },
          "duplicate": function ($event) {
            return _vm.duplicateConnaissance(connaissance, index);
          },
          "delete": function ($event) {
            return _vm.deleteFromActivity(_vm.form.activities[bigindex].activity_connaissances, index);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('add-button', {
      staticClass: "col-span-full flex items-center w-max",
      attrs: {
        "libelle": "Ajouter une connaissance",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addToActivity(_vm.form.activities[bigindex].activity_connaissances);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-y-5 sm:gap-x-10 mb-10"
    }, [_c('h5', {
      staticClass: "text-left text-base uppercase text-indigo-600 col-span-full"
    }, [_vm._v("\n                    Comportement / Attitudes\n                  ")]), _vm._v(" "), _c('draggable', _vm._b({
      staticClass: "col-span-full grid grid-cols-12 gap-y-5 sm:gap-x-10",
      on: {
        "start": function ($event) {
          _vm.drag = true;
        },
        "end": function ($event) {
          _vm.drag = false;
        }
      },
      model: {
        value: _vm.form.activities[bigindex].activity_comportements,
        callback: function ($$v) {
          _vm.$set(_vm.form.activities[bigindex], "activity_comportements", $$v);
        },
        expression: "form.activities[bigindex].activity_comportements"
      }
    }, 'draggable', _vm.dragOptions, false), _vm._l(_vm.form.activities[bigindex].activity_comportements, function (comportement, index) {
      return _c('div', {
        key: 'A' + index,
        staticClass: "col-span-full sm:col-span-6 flex items-center"
      }, [_c('input-text-with-action', {
        class: {
          'animate-pulse transition duration-1000 ease-linear bg-indigo-600 bg-opacity-50': _vm.isFlash.comportement == index
        },
        style: _vm.editable ? 'cursor:grab' : '',
        attrs: {
          "libelle": "",
          "name": 'comportement' + index,
          "necessary": true,
          "value": comportement.name,
          "disabled": !_vm.editable,
          "is-grabable": true,
          "placeholder": "Saisir le nom du comportement",
          "draggable": true,
          "prefix-text": index + 1 + '. '
        },
        on: {
          "input": function (newValue) {
            comportement.name = newValue;
          },
          "switchDraggable": function (newValue) {
            _vm.isDraggable = newValue;
          },
          "duplicate": function ($event) {
            return _vm.duplicateComportement(comportement, index);
          },
          "delete": function ($event) {
            return _vm.deleteFromActivity(_vm.form.activities[bigindex].activity_comportements, index);
          }
        }
      })], 1);
    }), 0), _vm._v(" "), _c('add-button', {
      staticClass: "col-span-full flex items-center w-max",
      attrs: {
        "libelle": "Ajouter un comportement",
        "disabled": !_vm.editable
      },
      on: {
        "add": function ($event) {
          return _vm.addToActivity(_vm.form.activities[bigindex].activity_comportements);
        }
      }
    })], 1)])]);
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-4 mt-10"
  }, [_c('h4', {
    staticClass: "text-indigo-600 col-span-full"
  }, [_vm._v("\n            Savoirs Fondamentaux\n          ")]), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "lecture",
      "libelle": "Lecture",
      "size": 5,
      "necessary": true,
      "value": _vm.form.lecture,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.lecture = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "ecriture",
      "libelle": "Ecriture",
      "size": 5,
      "necessary": true,
      "value": _vm.form.ecriture,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.ecriture = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "calcul",
      "libelle": "Calcul",
      "size": 5,
      "necessary": true,
      "value": _vm.form.calcul,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.calcul = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "informatique",
      "libelle": "Informatique",
      "size": 5,
      "necessary": true,
      "value": _vm.form.informatique,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.informatique = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "communication",
      "libelle": "Communication / Expression",
      "size": 5,
      "necessary": true,
      "value": _vm.form.communication,
      "disabled": !_vm.editable
    },
    on: {
      "input": function (newValue) {
        _vm.form.communication = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-4",
    attrs: {
      "name": "autres",
      "libelle": "Autres (précisez)",
      "size": 5,
      "necessary": true,
      "value": _vm.form.autres
    },
    on: {
      "input": function (newValue) {
        _vm.form.autres = newValue;
      }
    }
  })], 1)])], 1)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }